import { createReducer, on } from '@ngrx/store';
import { LocationsActions, RouterActions, AppActions, CampaignsActions, BusinessActions } from '@actions/index'
import { LocationModel } from '@models/index';
import { emptyLocationModel } from '../../../../core/utilities/data-utils';

export interface State {
    locations: LocationModel[];
    archivedLocations: string[];
    currentLocation: LocationModel;
    page: number;
    total: number;
    urls: Object[];
    existShortName: boolean;
    error: string;
    locationIdDeleted: string;
    last14DaysContactsCount: number;
    last14DaysReviewsCount: number;
    isLocationCreated: boolean;
    isSearchingLocations: boolean;
    isSearchingBusinessAndLocation: boolean;
}

const initialState: State = {
    locations: [],
    archivedLocations: [],
    currentLocation: emptyLocationModel(),
    page: -1,
    total: 0,
    urls: [],
    existShortName: false,
    error: "",
    locationIdDeleted: "",
    last14DaysContactsCount: 0,
    last14DaysReviewsCount: 0,
    isLocationCreated: false,
    isSearchingLocations: false,
    isSearchingBusinessAndLocation: false,
};

export const reducer = createReducer(
    initialState,
    on(LocationsActions.addLocationSuccess, (state, { location }) => ({ ...state, locations: [...state.locations, location], currentLocation: location, isLocationCreated: true })),
    on(LocationsActions.setCurrentLocation, (state, { location }) => ({ ...state, currentLocation: location })),
    on(LocationsActions.validateShortNameSuccess, (state, { exist }) => ({ ...state, existShortName: exist })),
    on(LocationsActions.clearCurrentLocation, (state) => ({ ...state, currentLocation: emptyLocationModel() })),
    on(LocationsActions.searchLocations, (state) => ({ ...state, isSearchingLocations: true, locations: [], total: 0 })),
    on(LocationsActions.searchLocationByQuery, (state) => ({ ...state, isSearchingLocations: true })),
    on(LocationsActions.searchLocationByQueryAndLandingUrls, (state) => ({ ...state, isSearchingLocations: true })),
    on(LocationsActions.searchLocationsSuccess, (state, { data, page, total }) => ({ ...state, isSearchingLocations: false, locations: data, page, total })),
    on(LocationsActions.searchLocationsFailed, (state) => ({ ...state, isSearchingLocations: false })),
    on(LocationsActions.searchArchivedLocationsSuccess, (state, { ids }) => ({ ...state, archivedLocations: ids })),
    on(LocationsActions.findLocationByIdSuccess, (state, { data }) => ({ ...state, currentLocation: data })),
    on(LocationsActions.editLocationSuccess, (state, { location }) => ({ ...state, locations: state.locations.map((locationItem => location.id === locationItem.id ? location : locationItem)), currentLocation: location })),
    on(LocationsActions.deleteLocationSuccess, (state, { locationIdDeleted }) => ({ ...state, locationIdDeleted, locations: state.locations.filter(location => location.id !== locationIdDeleted) })),
    on(LocationsActions.archiveLocationSuccess, (state, { locationId }) => ({ ...state, locations: state.locations.filter(location => location.id !== locationId) })),
    on(LocationsActions.getUrlsSuccess, (state, { urls }) => ({ ...state, urls })),
    on(LocationsActions.locationError, (state, { error }) => ({ ...state, error })),
    on(LocationsActions.getContactsLast14DaysSuccess, (state, { contactCount }) => ({ ...state, last14DaysContactsCount: contactCount })),
    on(LocationsActions.getReviewsLast14DaysSuccess, (state, { reviewCount }) => ({ ...state, last14DaysReviewsCount: reviewCount })),
    on(LocationsActions.searchAndNavigateToBusinessLocation, (state, { }) => ({ ...state, isSearchingBusinessAndLocation: true, isSearchingLocations: true, })),
    on(LocationsActions.searchAndNavigateToBusinessLocationComplete, (state, { }) => ({ ...state, isSearchingBusinessAndLocation: false, isSearchingLocations: false, })),
    on(BusinessActions.searchBusinessByIdSuccess, BusinessActions.selectBusinessProfile, (state, { business }) => ({
        ...state,
        currentLocation: state.currentLocation.businessId == business.id
            ? state.currentLocation
            : emptyLocationModel()
    })),
    on(LocationsActions.upgradePlanSuccess, (state, { location }) => ({ ...state, currentLocation: location })),
    on(CampaignsActions.changeLocationPreferredCampaignSuccess, (state, { data }) => ({ ...state, currentLocation: data })),
    on(RouterActions.navigateAuth, () => ({ ...initialState })),
    on(AppActions.clearState, (state) => {
        return ({
            ...state,
            locations: [],
            urls: [],
        })
    }),
    on(LocationsActions.enableOrDisableAutoReplyAiSuccess, (state, { location }) => ({ ...state, currentLocation: location })),
);

export const getLocations = (state: State) => state.locations;
export const getArchivedLocations = (state: State) => state.archivedLocations;
export const getCurrentLocation = (state: State) => state.currentLocation;
export const getExistShortName = (state: State) => state.existShortName;
export const getPage = (state: State) => state.page;
export const getTotal = (state: State) => state.total;
export const getUrl = (state: State) => state.urls;
export const getError = (state: State) => state.error;
export const getContactsLast14Days = (state: State) => state.last14DaysContactsCount;
export const getReviewsLast14Days = (state: State) => state.last14DaysReviewsCount;
export const isLocationCreated = (state: State) => state.isLocationCreated;
export const isSearchingLocations = (state: State) => state.isSearchingLocations;
export const isSearchingBusinessAndLocation = (state: State) => state.isSearchingBusinessAndLocation;
